import { render, staticRenderFns } from "./bloodPressureRecord.vue?vue&type=template&id=6653df96&scoped=true"
import script from "./bloodPressureRecord.vue?vue&type=script&lang=js"
export * from "./bloodPressureRecord.vue?vue&type=script&lang=js"
import style0 from "./bloodPressureRecord.vue?vue&type=style&index=0&id=6653df96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653df96",
  null
  
)

export default component.exports